"use client"

import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Paper,
} from "@mui/material"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"
import { useEffect, useState, useMemo, useCallback } from "react"
import MUIDataTable from "mui-datatables"
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined"

const initialState = {
  descripcion: "",
  matricula: "",
}

const formatPhoneNumber = (prof) => {
  const parts = []
  if (prof.descripcion) parts.push(prof.descripcion)
  if (prof.matricula) parts.push(prof.matricula)
  return parts.join(": ")
}

const ProfesionesDialog = ({ onSave, onClose, itemCrud, itemsCrud, actionCrud, setMessage, setShowMessage }) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState)
  const [profesiones, setProfesiones] = useState([])
  const [selectedRow, setSelectedRow] = useState(null)

  useEffect(() => {
    if (actionCrud === "create") {
      setItemCrudLocal(initialState)
    } else {
      setItemCrudLocal(itemCrud)
    }

    const _itemCrud = itemsCrud
    if (_itemCrud.length > 0)
      setProfesiones(_itemCrud)
    else
      setProfesiones([])

  }, [actionCrud, itemCrud, itemsCrud])



  useEffect(() => {
    if (actionCrud === "create") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }

    if (itemsCrud.length > 0) {
      const firstTelefono = itemsCrud[0]; // Seleccionar el primer domicilio
      setItemCrudLocal({
        id: firstTelefono.id,
        descripcion: firstTelefono.descripcion,
        matricula: firstTelefono.matricula,
      });

      setSelectedRow(0); // Marcar la primera fila como seleccionada
    }

    const _itemCrud = itemsCrud;
    if (_itemCrud.length > 0) {
      setProfesiones(_itemCrud);
    }
  }, [actionCrud, itemCrud, itemsCrud]);



  const handleObtieneTelefono = useCallback(
    (dataIndex) => {
      setSelectedRow(dataIndex)
      const selectedTelefono = profesiones[dataIndex]
      setItemCrudLocal({
        id: selectedTelefono.id,
        descripcion: selectedTelefono.descripcion,
        matricula: selectedTelefono.matricula,
      })
    },
    [profesiones],
  )

  const tableColumns = useMemo(
    () => [
      {
        name: "id",
        label: "ID",
        options: {
          filter: false,
          sort: false,
          display: "excluded",
        },
      },
      {
        name: "descripcion",
        label: "Profesión",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({
            style: {
              textAlign: 'left',
              width: '450px',
            }
          }),
          setCellHeaderProps: () => ({
            style: {
              textAlign: 'left',
              width: '450px',
            },
          }),
          customBodyRenderLite: (dataIndex, rowIndex) => {
            let _val = profesiones[dataIndex].descripcion ? profesiones[dataIndex].descripcion.toUpperCase() : '';
            return _val;
          },
        },
      },
      {
        name: "matricula",
        label: "N° de Matrícula",
        options: {
          filter: false,
          sort: false,
        },
        setCellProps: () => ({
          style: {
            textAlign: 'left',
            width: '450px',
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'left',
            width: '450px',
          },
        }),
      },
      {
        name: "actions",
        label: "Acciones",
        options: {
          filter: false,
          sort: false,
          empty: true,
          setCellProps: () => ({
            style: {
              textAlign: 'center'
            }
          }),
          setCellHeaderProps: () => ({
            style: {
              textAlign: 'center'
            },
          }),
          customBodyRenderLite: (dataIndex) => (
            <Tooltip title="Ver Profesión">
              <IconButton size="small" aria-label="view" onClick={() => handleObtieneTelefono(dataIndex)}>
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          ),
        },
      },
    ],
    [handleObtieneTelefono],
  )

  const tableOptions = useMemo(
    () => ({
      download: false,
      filter: false,
      print: false,
      search: false,
      viewColumns: false,
      pagination: false,
      elevation: 1,
      selectableRows: "none",
      textLabels: {
        body: {
          noMatch: "No se encontraron registros",
        },
      },
      setRowProps: (row, dataIndex) => ({
        style: {
          backgroundColor: selectedRow === dataIndex ? "#e8f5e9" : "inherit",
        },
      }),
    }),
    [selectedRow],
  )

  const handleCloseDialog = () => {
    onClose()
  }

  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    })
  }

  const handleSave = async () => {
    if (itemCrudLocal.descripcion === "" || itemCrudLocal.matricula === "") {
      setMessage({
        severity: "error",
        messageText: "Debes completar todos los campos.",
      })
      setShowMessage(true)
      return
    }
    const _itemCrud = {
      id: itemCrudLocal.id,
      descripcion: itemCrudLocal.descripcion,
      matricula: itemCrudLocal.matricula,
    }
    // Placeholder for save logic
    const response = { ok: true, messageText: "Saved successfully!", messageSeverity: "success" }

    if (response.ok) {
      onSave(_itemCrud)
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    })
    setShowMessage(true)
  }

  const handleCopyToClipboard = () => {
    const formattedPhoneNumber = formatPhoneNumber(itemCrudLocal)
    navigator.clipboard
      .writeText(formattedPhoneNumber)
      .then(() => {
        console.log("Profesión copiada")
        setMessage({
          severity: "success",
          messageText: "Profesión copiada al portapapeles.",
        })
        setShowMessage(true)
      })
      .catch((err) => {
        console.error("Error al copiar la Profesión", err)
        setMessage({
          severity: "error",
          messageText: "Error al copiar la Profesión",
        })
        setShowMessage(true)
      })
  }

  return (
    <Dialog
      open={true}
      onClose={handleCloseDialog}
      maxWidth="md"
      fullWidth={true}
      scroll="paper"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {actionCrud === "view" ? "Ver" : "Nueva"} Profesión
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "20vh",
            mb: 2,
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 3,
              maxWidth: "800px",
              width: "100%",
              m: "5px",
              boxSizing: "border-box",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "20vh",
                mb: 4,
                marginTop: 2,
                overflowX: "auto",
              }}
            >
              <MUIDataTable
                title={"Listado de Profesiones"}
                columns={tableColumns}
                options={tableOptions}
                data={profesiones ? profesiones : []}
              />
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <Box display="flex" alignItems="center">
                  {/* <h3 style={{ marginRight: "50px", marginLeft: "20px" }}>Profesión</h3> */}
                  <TextField
                    label="Profesión"
                    sx={{ width: "80%" }}
                    inputProps={{
                      autoComplete: "off",
                      readOnly: actionCrud === "view",
                    }}
                    id="descripcion"
                    variant="outlined"
                    size="small"
                    name="descripcion"
                    value={itemCrudLocal.descripcion?.toUpperCase() || ""}
                    onChange={handleChange}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>

                <Box display="flex" alignItems="center">
                  {/* <h3 style={{ marginRight: "50px", marginLeft: "20px" }}>N° de Matrícula</h3> */}
                  <TextField
                    label="N° de Matrícula"
                    sx={{ width: "100%" }}
                    inputProps={{
                      autoComplete: "off",
                      readOnly: actionCrud === "view",
                    }}
                    id="matricula"
                    variant="outlined"
                    size="small"
                    name="matricula"
                    value={itemCrudLocal.matricula || ""}
                    onChange={handleChange}
                  />
                </Box>
              </Grid>

            </Grid>
{/* 
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button variant="contained" color="primary" onClick={handleCopyToClipboard}>
                Copiar Profesión
              </Button>
            </Box> */}

            <Box sx={{ textAlign: "right", mb: 2, mt: 2 }}>
              {actionCrud !== "view" && (
                <Button sx={{ mr: 1 }} variant="contained" onClick={handleSave} startIcon={<SaveIcon />}>
                  Guardar
                </Button>
              )}
              <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
                {actionCrud === "view" ? "Volver" : "Cancelar"}
              </Button>
            </Box>
          </Paper>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default ProfesionesDialog

